import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { UploadStructure } from '../../../../property-editor/editors/upload/upload.structure';
import { AXFWidgetDesigner } from '../../../config/widget';

@Component({
  selector: '[axf-widget-image]',
  templateUrl: './image-widget.designer.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AXFImageWidgetDesigner extends AXFWidgetDesigner {
  value!: UploadStructure;
  alt!: string;
  constructor(
    private el: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  override onRender(): void {
    this.applyStyle(this.el.nativeElement.querySelector('img') as HTMLElement);
    this.cdr.markForCheck();
  }
}
